import { Directive, HostListener, input, OnDestroy, OnInit, output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

/**
 * Debounce click directive
 * @class DebounceClickDirective
 * @typedef {DebounceClickDirective}
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Directive( {
    selector: '[debounceClick]'
} )
export class DebounceClickDirective implements OnInit, OnDestroy {
    /** debouce duration */
    readonly debounceTime = input( 500 );
    /** click event emitter to notify parent component */
    doClick = output<MouseEvent>();

    /** subscription handler */
    #clicks = new Subject<MouseEvent>();
    #subscription: Subscription = new Subscription();

    /** set subscription and wait for debounce duration before clicks will be emitted */
    ngOnInit() {
        this.#subscription = this.#clicks
            .pipe( debounceTime( this.debounceTime() ) )
            .subscribe( ( e ) => this.doClick.emit( e ) );
    }

    /** unsubscribe from event handler subscription */
    ngOnDestroy() {
        this.#subscription.unsubscribe();
    }

    /** click event handler */
    @HostListener( 'click', [ '$event' ] )
    clickEvent( event: MouseEvent ) {
        event.preventDefault();
        event.stopPropagation();
        this.#clicks.next( event );
    }
}
